import request from 'services/axios'

/**
 * The caller's own bank accounts.
 *
 * `cursor` is OMITTED when `pageParam` is falsy, which matters: the endpoint
 * is cursor-paginated and `?cursor=0` is not a valid cursor — it answers
 * **404**, react-query turns that into `data === undefined`, and the caller
 * renders an empty card list to somebody who has fourteen registered accounts.
 *
 * Verified live: `?cursor=0` → 404 · `?cursor=1` → 200/14 rows · no cursor →
 * 200/14 rows. Two call sites passed 0 (the cashbox claim screen and the
 * withdrawal wizard) and both showed no cards at all.
 */
export const getBankCards = async (pageParam?: number | string | null) => {
    const query = pageParam ? `?cursor=${pageParam}` : ''
    const { data }: { data: IBankCards } = await request.get(
        `/api/v1/account/bankaccounts/${query}`
    )
    return data
}
export const addNewBankCard = async (cardsNumber: string, isIban: boolean) => {
    const { data }: { data: IAddCardNumber } = await request.post(
        `/api/v1/account/bankaccounts/`,
        {
            ...(!isIban ? { card_number: cardsNumber } : { iban: cardsNumber }),
            ownership_type: 'baotmo',
        }
    )
    return data
}

export const verifyNewBankCard = async (cardsNumber: number) => {
    const { data } = await request.patch(
        `/api/v1/account/bankaccounts/${cardsNumber}/`,
        {
            is_member_verified: true,
        }
    )
    return data
}

export const setDefault = async (id: number) => {
    const { data } = await request.post(
        `/api/v1/account/bankaccounts/${id}/setDefault`
    )
    return data
}

export const deleteCard = async (id: number) => {
    const { data } = await request.delete(`/account/bankaccount/${id}/`)
    return data
}

export const historyPayments = async (id: number, pageParams: number) => {
    const { data }: { data: IHistoryCardManagement } = await request.get(
        `/api/v1/payment/transactions/?bank_account=${id}&cursor=${pageParams}`
    )
    return data
}
